// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__Un-1F","active":"IconButton_active__M6k6S"};